import PackagesApi from 'frontend/api/paquetes';
import Pagination from 'frontend/commons/Pagination';
import LoadSpinner from 'frontend/commons/spinner';
import PackageCard from 'frontend/components/packages/packageCard';
import { PackageCardProvider } from 'frontend/contexts/PackageCardContext';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Flex from '../../../commons/Flex';
import { useFilters } from '../../../contexts/FiltersContext';
import './PackagesListView.css';
import AsideFilters from './components/AsideFilters';

const INITIAL_PACKAGES_STATE = {
  isLoading: true,
  data: null,
  error: false,
  availableFilters: null,
};

const PackagesListView = () => {
  const { t } = useTranslation('layout');
  const { filters } = useFilters();
  const { search } = useLocation();
  const [packages, setPackages] = useState(INITIAL_PACKAGES_STATE);
  const [totalPages, setTotalPages] = useState();

  const filtersToSearchParams = useMemo(() => {
    if (!filters || !search) return '';

    return (
      '&' +
      new URLSearchParams(
        Object.fromEntries(Object.entries(filters).map(([key, { value }]) => [key, value]))
      ).toString()
    );
  }, [filters, search]);

  const fetchPackages = useCallback(async () => {
    try {
      setPackages({
        ...packages,
        isLoading: true,
      });
      window.scrollTo(0, 0);
      const query = search + filtersToSearchParams;
      const packageData = await PackagesApi.getPackagesV2(query);

      setPackages({
        isLoading: false,
        data: packageData,
        error: false,
        availableFilters: packageData.availableFilters,
      });

      setTotalPages(packageData.totalPages);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error(error);
      setPackages((prev) => ({ ...prev, isLoading: false, error: true }));
    }
  }, [search, filtersToSearchParams]);

  useEffect(() => {
    fetchPackages();
  }, [fetchPackages]);

  if (packages.isLoading) {
    return (
      <div className="container package__list-view__area loading-packages">
        <h1>{t('packages.searching')}</h1>
        <LoadSpinner />
      </div>
    );
  }

  if (packages.data?.length === 0) {
    return (
      <div className="container package__list-view__area package__list-view__area--empty">
        <h1>{t('packages.no_results')}</h1>
      </div>
    );
  }
 

  return (
    <div className="package__list-view__area">
      <Flex className="package__list__view__wrapper--package">
        {packages.availableFilters && (
          <AsideFilters availableFilters={packages.availableFilters} />
        )}
        <Flex key={search} vertical className="package__list__view__wrapper--package__results">
          {packages.data.map((packageData) => (
            <PackageCardProvider
              key={`package-${packageData.id}`}
              packageData={packageData}
              query={search + filtersToSearchParams}
            >
              <PackageCard {...packageData} query={search + filtersToSearchParams} />
            </PackageCardProvider>
          ))}
        </Flex>
      </Flex>
      <Pagination totalPages={totalPages} />
    </div>
  );
};

export default PackagesListView;